/* WaveBeats — Product Form JS
 * File: assets/wavebeats-form.js
 * Companion variant IDs — replace the 0 values with real Shopify variant IDs
 */

var WB_VARIANTS = {
  chanson: 52663551885645,  // Chanson Disney personnalisée (+29€)
  express: 50345935634765,  // Livraison Express (+39€)
  youtube: 52631939154253,  // Streaming YouTube (+14€)
  duree_60s:  52634347012429,  // Durée 60 secondes (+19€)
  duree_90s:  52634347045197,  // Durée 90 secondes (+29€)
  // (31/08) UN SEUL produit « Ajouter Personnage » (15 €), piloté par la QUANTITÉ :
  // 3 personnes → qty 1, 4 personnes → qty 2. Le panier affiche une ligne « × 2 » au lieu de
  // deux lignes identiques, et un 5ᵉ personnage ne demanderait aucun nouveau produit.
  perso: 52638710366541
};

var UPLOAD_ENDPOINT = 'https://wavebeats-production.up.railway.app/upload-photo';

/* ─── Accordion ─────────────────────────────────────────────────────────── */

function wbToggle(header) {
  var body = header.nextElementSibling;
  var isClosed = header.classList.contains('wb-closed');
  if (isClosed) {
    header.classList.remove('wb-closed');
    body.classList.remove('wb-hidden');
    wbCadre(header);
  } else {
    header.classList.add('wb-closed');
    body.classList.add('wb-hidden');
  }
}

/* (15/10, Rayan) Une étape qu'on ouvre vient SE CALER EN HAUT de l'écran, juste sous l'en-tête
   collant du site : avant, l'étape s'ouvrait là où elle était (souvent à moitié hors écran, le
   client devait faire défiler pour trouver le premier champ). Le défilement part APRÈS que
   l'étape est dépliée (sinon la hauteur mesurée est celle d'avant l'ouverture). */
function wbCadre(header) {
  var step = header.closest('.wb-step') || header;
  requestAnimationFrame(function () {
    var fixe = document.querySelector('.shopify-section-header-sticky, .section-header');
    var marge = (fixe && getComputedStyle(fixe).position === 'sticky' ? fixe.offsetHeight : 0) + 10;
    var y = step.getBoundingClientRect().top + window.scrollY - marge;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  });
}

/* ─── Remove photo ───────────────────────────────────────────────────────── */

function wbRemovePhoto(btn, zoneId, hiddenId, event) {
  if (event) { event.stopPropagation(); event.preventDefault(); }
  var zone = document.getElementById(zoneId);
  var hidden = document.getElementById(hiddenId);
  if (zone) {
    zone.classList.remove('wb-has-file', 'wb-uploading');
    var preview = zone.querySelector('.wb-preview');
    if (preview) {
      preview.style.display = 'none';
      var img = preview.querySelector('img');
      if (img) img.src = '';
    }
    var fileInput = zone.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = '';
    var pct = zone.querySelector('.wb-progress-pct');
    if (pct) pct.textContent = '';
    var content = zone.querySelector('.wb-upload-content');
    if (content) content.style.display = '';
  }
  if (hidden) hidden.value = '';
  var driveInput = document.getElementById(hiddenId + '-drive-id');
  if (driveInput) driveInput.value = '';
  _wbUploading[zoneId] = false;
}

/* ─── Thème autre toggle ─────────────────────────────────────────────────── */

function wbToggleThemeAutre(select) {
  var box = document.getElementById('wb-f-theme-autre');
  if (!box) return;
  if (select.value === 'Autre') {
    box.style.display = '';
    var input = box.querySelector('input');
    if (input) { input.required = true; input.disabled = false; }
  } else {
    box.style.display = 'none';
    var input = box.querySelector('input');
    if (input) { input.required = false; input.value = ''; input.disabled = true; }
  }
}

/* ─── Personnage 2 toggle ────────────────────────────────────────────────── */

function wbTogglePers2(select) {
  var box = document.getElementById('wb-pers2');
  if (!box) return;
  if (select.value === 'Oui') {
    box.classList.add('wb-visible');
  } else {
    box.classList.remove('wb-visible');
    // clear pers2 fields so they don't fail validation when hidden
    var inputs = box.querySelectorAll('input[type="text"], select');
    inputs.forEach(function(el) { el.value = ''; });
    var urlInput = document.getElementById('wb-photo2-url');
    if (urlInput) urlInput.value = '';
    var zone = document.getElementById('wb-upload2');
    if (zone) {
      zone.classList.remove('wb-has-file', 'wb-uploading');
      var fn = zone.querySelector('.wb-file-name');
      if (fn) fn.textContent = '';
    }
  }
}

/* ─── Personne 2 : bouton « Ajouter une personne » (form FR) ───────────────
 * Remplace le select Oui/Non. Le champ caché properties[ajouter-personnage]
 * garde la même valeur Oui/Non → Sheet/dashboard/scripts inchangés.
 * wbTogglePers2 ci-dessus reste pour les forms UK/Mariage (JS partagé). */

function _wbPersBlocks() {
  var b = Array.prototype.slice.call(document.querySelectorAll('.wb-pers'));
  if (!b.length) { var p2 = document.getElementById('wb-pers2'); if (p2) b = [p2]; }
  return b;
}

/* (03/09) Un bloc personnage FERMÉ ne doit RIEN soumettre. Sans ça, la commande
   embarquait « personnage3 : », « _photo-personnage3 : »… VIDES — visibles dans le
   panier et dans la colonne D du Sheet. Un champ `disabled` n'est pas soumis.
   Portée : form FR uniquement (présence de #wb-add-person) — les forms UK/Mariage
   partagent ce JS mais pilotent leur bloc via wbTogglePers2, on n'y touche pas. */
function _wbMajChampsFermes() {
  if (!document.getElementById('wb-add-person')) return;
  _wbPersBlocks().forEach(function (b) {
    var ferme = !b.classList.contains('wb-visible');
    b.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = ferme; });
  });
}

function _wbPersSync() {
  _wbMajChampsFermes();
  var blocks = _wbPersBlocks();
  var open = blocks.filter(function(b) { return b.classList.contains('wb-visible'); }).length;
  var val = document.getElementById('wb-ajouter-val');
  var btn = document.getElementById('wb-add-person');
  if (val) val.value = open > 0 ? 'Oui' : 'Non';
  var suivant = blocks.filter(function(b) { return !b.classList.contains('wb-visible'); })[0];
  if (btn) btn.classList.toggle('wb-hidden', !suivant);
  /* (11/09) Sélecteur On/Off + nombre : tout suit le nombre de blocs ouverts (source
     unique — « Retirer » sur un bloc met aussi les deux rangées à jour). */
  var onoff = document.getElementById('wb-pers-onoff');
  var nb = document.getElementById('wb-nbpers-pills');
  if (onoff) onoff.checked = open > 0;
  if (nb) {
    nb.style.display = open > 0 ? '' : 'none';
    [...nb.querySelectorAll('.wb-pill')].forEach(function(p, i) {
      p.classList.toggle('wb-on', i === open - 1);
    });
  }
  // (03/09, demande Rayan) TRANSPARENCE : le bouton annonce le prix dès que le prochain
  // ajout est PAYANT. La personne 2 est incluse dans le prix de base ; à partir de la 3ᵉ,
  // chaque personne coûte. Le prix vient de `data-prix` sur le bouton : les forms UK et
  // Mariage, qui partagent ce JS, n'en ont pas → leur libellé reste intact.
  if (btn && btn.dataset && btn.dataset.prix) {
    if (!btn.dataset.base) btn.dataset.base = btn.textContent.trim();
    var payant = suivant && suivant.id !== 'wb-pers2';
    // (11/10, Rayan) le bouton dit QUEL personnage on ajoute : « 2ème », « 3ème (+15 €) », « 4ème (+15 €) »
    var _n = suivant ? parseInt(String(suivant.id).replace('wb-pers', ''), 10) : 0;
    var _lib = _n >= 2 ? '＋ Ajouter ' + _n + 'ème Personnage' : btn.dataset.base;
    btn.innerHTML = _lib
      + (payant ? ' <span class="wb-prix">(' + btn.dataset.prix + ')</span>' : '');
  }
  // (31/08) Personnages PAYANTS = blocs ouverts au-delà du 2ᵉ (le 2ᵉ est inclus dans le prix).
  // Une seule ligne panier, quantité = nombre de personnes en plus.
  var extra = 0;
  for (var _i = 3; _i <= 4; _i++) {
    var _p = document.getElementById('wb-pers' + _i);
    if (_p && _p.classList.contains('wb-visible')) extra++;
  }
  if (extra > 0) wbSetCompanionQty('perso', extra);
  else wbRemoveCompanion('perso');
  if (typeof wbTotal === 'function') wbTotal();
}

function wbAddPerson() {
  var next = _wbPersBlocks().filter(function(b) { return !b.classList.contains('wb-visible'); })[0];
  if (!next) return;
  next.classList.add('wb-visible');
  _wbPersSync();
  var first = next.querySelector('input[type="text"]');
  if (first) first.focus();
}

function wbRemovePerson(btn) {
  var box = (btn && btn.closest && btn.closest('.wb-pers')) || document.getElementById('wb-pers2');
  if (!box) return;
  // si on retire la personne 2 alors que la 3 est ouverte : on retire la dernière ouverte (pas de trou)
  var opened = _wbPersBlocks().filter(function(b) { return b.classList.contains('wb-visible'); });
  if (opened.length && opened[opened.length - 1] !== box) box = opened[opened.length - 1];
  box.classList.remove('wb-visible');
  box.querySelectorAll('input[type="text"], input[type="hidden"], select').forEach(function(el) { el.value = ''; });
  box.querySelectorAll('.wb-pill.wb-on').forEach(function(b) { b.classList.remove('wb-on'); });
  box.querySelectorAll('.wb-field').forEach(function(f) { f.classList.remove('wb-invalid'); });
  box.querySelectorAll('.wb-eye-name').forEach(function(e) { e.textContent = ''; });
  var removeBtn = box.querySelector('.wb-preview-remove');
  var zone = box.querySelector('.wb-upload-zone');
  if (removeBtn && zone) wbRemovePhoto(removeBtn, zone.id, zone.id.replace('wb-upload', 'wb-photo') + '-url', null);
  _wbPersSync();
}

/* ─── Boutons-pilules (Occasion, Ton) — form FR ─────────────────────────────
 * Un groupe .wb-pills pilote un input caché (même name/valeurs qu'avant). */

function wbPick(btn, hiddenId, otherInputId) {
  var group = btn.parentNode;
  group.querySelectorAll('.wb-pill').forEach(function(b) { b.classList.remove('wb-on'); });
  btn.classList.add('wb-on');
  var hidden = document.getElementById(hiddenId);
  var other = otherInputId ? document.getElementById(otherInputId) : (group.parentNode.querySelector('input.wb-input[id$="-autre"]'));
  if (otherInputId) {
    if (other) { other.style.display = ''; other.focus(); }
    if (hidden) hidden.value = other ? other.value.trim() : '';
  } else {
    if (other) { other.style.display = 'none'; other.value = ''; }
    if (hidden) hidden.value = btn.getAttribute('data-v') || btn.textContent.trim();
  }
  var field = btn.closest('.wb-field');
  if (field && hidden && hidden.value) field.classList.remove('wb-invalid');
}

/* ─── Options en boutons + total en direct — form FR ────────────────────────
 * wbPickOpt : pilule → input caché (mêmes valeurs qu'avant) → même handler
 * companion (wbHandleDuree/Musique/Livraison/Youtube) qu'un <select>. */

// ⚠️ Doivent RESTER ALIGNÉS sur les prix des variantes Shopify — un écart fait
// afficher un total faux au client (express 39 → 49 € le 03/09, puis 49 → 39 € le 03/10).
var WB_PRICES = { chanson: 29, express: 39, youtube: 14, duree_60s: 19, duree_90s: 29, perso: 15 };

function wbPickOpt(btn, hiddenId, handlerName) {
  wbPick(btn, hiddenId);
  var hidden = document.getElementById(hiddenId);
  var fn = window[handlerName];
  if (hidden && typeof fn === 'function') fn({ value: hidden.value });
  wbTotal();
}

function wbToggleOpt(card, hiddenId, onValue, offValue, handlerName) {
  card.classList.toggle('wb-on');
  var hidden = document.getElementById(hiddenId);
  if (hidden) hidden.value = card.classList.contains('wb-on') ? onValue : offValue;
  var fn = window[handlerName];
  if (hidden && typeof fn === 'function') fn({ value: hidden.value });
  wbTotal();
}

function wbNarration() {
  var parts = [];
  ['wb-scene1', 'wb-scene2', 'wb-scene3'].forEach(function(id, i) {
    var el = document.getElementById(id);
    if (el && el.value.trim()) parts.push('Scène ' + (i + 1) + ' : ' + el.value.trim());
  });
  var hidden = document.getElementById('wb-narration-val');
  if (hidden) hidden.value = parts.join('\n');
  var field = hidden && hidden.closest('.wb-field');
  if (field && hidden.value) field.classList.remove('wb-invalid');
}

document.addEventListener('input', function(e) {
  if (e.target && e.target.name === 'properties[Narration]') wbTotal();
});

function wbTotal() {
  var box = document.querySelector('.wb-total');
  if (!box) return;
  var v = function(id) { var e = document.getElementById(id); return e ? e.value : ''; };
  var total = parseFloat(box.getAttribute('data-base')) || 0;
  var detail = [];
  // (31/08) le 2ᵉ personnage est INCLUS ; chaque bloc au-delà coûte WB_PRICES.perso
  var _open = 1;
  for (var _n = 2; _n <= 4; _n++) {
    var _b = document.getElementById('wb-pers' + _n);
    if (_b && _b.classList.contains('wb-visible')) _open = _n;
  }
  if (_open > 2) {
    total += WB_PRICES.perso * (_open - 2);
    detail.push(_open + ' personnes');
  }
  var d = v('wb-duree-val');
  detail.push(d === '60 secondes' ? 'Film 1 min' : d === '90 secondes' ? 'Film 1 min 30' : 'Film 30 s');
  if (d === '60 secondes') total += WB_PRICES.duree_60s;
  if (d === '90 secondes') total += WB_PRICES.duree_90s;
  if (v('wb-musique-val') === 'Chanson personnalisée') { total += WB_PRICES.chanson; detail.push('chanson'); }
  if (v('wb-livraison-val') === 'Express (24H)') { total += WB_PRICES.express; detail.push('express 24 h'); }
  if (v('wb-youtube-val') === 'Oui') { total += WB_PRICES.youtube; detail.push('YouTube'); }
  var t = document.getElementById('wb-total'), dd = document.getElementById('wb-total-detail');
  if (t) t.textContent = total.toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  if (dd) dd.textContent = detail.join(' · ');
  /* (11/09, Rayan) RÉCAP ligne par ligne : une option = une ligne avec SON prix.
     L'ancienne ligne « Film 1 min · chanson · express » était illisible. */
  var rc = document.getElementById('wb-recap-lignes');
  /* (11/09, Rayan) Le récap n'apparaît qu'une fois L'HISTOIRE remplie : pas de facture
     à 78,90 € sous le nez d'un visiteur qui n'a rien choisi (la chanson est précochée),
     mais les prix sont là dès qu'on arrive aux options. UNE condition, zéro règle dupliquée. */
  var _narr = document.querySelector('[name="properties[Narration]"]');
  var _tot = document.querySelector('.wb-total');
  if (_tot) _tot.style.display = (_narr && _narr.value.trim()) ? 'block' : 'none';
  if (rc) {
    var eur = function(n) { return n.toFixed(2).replace('.', ',').replace(',00', '') + ' €'; };
    var base = parseFloat(box.getAttribute('data-base')) || 0;
    var lignes = [['Film personnalisé', eur(base)]];
    if (d === '60 secondes') lignes.push(['Durée 1 minute', '+' + eur(WB_PRICES.duree_60s)]);
    if (d === '90 secondes') lignes.push(['Durée 1 min 30', '+' + eur(WB_PRICES.duree_90s)]);
    if (v('wb-musique-val') === 'Chanson personnalisée') lignes.push(['Chanson personnalisée', '+' + eur(WB_PRICES.chanson)]);
    if (v('wb-livraison-val') === 'Express (24H)') lignes.push(['Livraison Express 24 h', '+' + eur(WB_PRICES.express)]);
    if (v('wb-youtube-val') === 'Oui') lignes.push(['Lien YouTube privé', '+' + eur(WB_PRICES.youtube)]);
    if (_open > 2) lignes.push([(_open - 2) === 1 ? '3\u1D49 personnage' : '3\u1D49 + 4\u1D49 personnages', '+' + eur(WB_PRICES.perso * (_open - 2))]);
    rc.innerHTML = lignes.map(function(l) {
      return '<div class="wb-recap-l"><span>' + l[0] + '</span><span>' + l[1] + '</span></div>';
    }).join('');
  }
}

/* ─── Prénom dans la question des yeux (form FR) ───────────────────────── */
function wbEyeName(input, targetId, fallback) {
  var el = document.getElementById(targetId);
  if (!el) return;
  var first = (input.value || '').trim().split(/[\s,]+/)[0] || '';
  var cap = first ? first.charAt(0).toUpperCase() + first.slice(1) : '';
  el.textContent = first ? (/^[aeiouyhàâäéèêëîïôöùûü]/i.test(first) ? " d'" : ' de ') + cap : fallback;
}

/* ─── Photo upload ───────────────────────────────────────────────────────── */

var _wbUploading = {};  // { zoneId: true/false } — bloque le submit si upload en cours

function wbUpload(event, zoneId, hiddenId) {
  var file = event.target.files[0];
  if (!file) return;

  var zone = document.getElementById(zoneId);
  var hidden = document.getElementById(hiddenId);
  if (!zone || !hidden) return;

  // 1. Afficher miniature immédiatement (lecture locale — instantané)
  var preview = zone.querySelector('.wb-preview');
  if (preview) {
    var previewImg = preview.querySelector('img');
    var previewName = preview.querySelector('.wb-preview-name');
    if (previewImg) previewImg.src = URL.createObjectURL(file);
    if (previewName) previewName.textContent = file.name;
    preview.style.display = 'flex';
  }
  zone.classList.add('wb-uploading', 'wb-has-file');
  var pct = zone.querySelector('.wb-progress-pct');
  if (pct) pct.textContent = 'Téléchargement en cours...';

  // 2. Après 3s : afficher "✓ Photo ajoutée" même si upload encore en cours
  setTimeout(function() {
    if (_wbUploading[zoneId]) {
      zone.classList.remove('wb-uploading');
      if (pct) pct.textContent = '✓ Photo ajoutée';
      var field = zone.closest('.wb-field');
      if (field) field.classList.remove('wb-invalid');
    }
  }, 3000);

  // 2. Marquer upload en cours (bloque submit)
  _wbUploading[zoneId] = true;
  hidden.value = '';

  function resizeToJpeg(file, maxDim, quality, callback) {
    var img = new Image();
    var url = URL.createObjectURL(file);
    img.onload = function() {
      URL.revokeObjectURL(url);
      var w = img.width, h = img.height;
      if (w > maxDim || h > maxDim) {
        var ratio = Math.min(maxDim / w, maxDim / h);
        w = Math.round(w * ratio);
        h = Math.round(h * ratio);
      }
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      canvas.toBlob(callback, 'image/jpeg', quality);
    };
    img.onerror = function() { callback(null); };
    img.src = url;
  }

  function doUpload(blob, attemptsLeft) {
    var attempt = 6 - attemptsLeft;  // 1..5
    var delay = attemptsLeft < 5 ? Math.min(2000 * Math.pow(2, attempt - 2), 16000) : 0;

    setTimeout(function() {
      var controller = new AbortController();
      var tid = setTimeout(function() { controller.abort(); }, 20000);
      var formData = new FormData();
      formData.append('file', blob, 'photo_' + Date.now() + '.jpg');
      fetch(UPLOAD_ENDPOINT, { method: 'POST', body: formData, signal: controller.signal })
        .then(function(r) {
          clearTimeout(tid);
          if (!r.ok) throw new Error('Upload ' + r.status);
          return r.json();
        })
        .then(function(data) {
          hidden.value = data.url;
          var driveIdInput = document.getElementById(hiddenId + '-drive-id');
          if (driveIdInput) driveIdInput.value = data.file_id;
          _wbUploading[zoneId] = false;
          zone.classList.remove('wb-uploading');
          if (pct) pct.textContent = '✓';
          var field = zone.closest('.wb-field');
          if (field) field.classList.remove('wb-invalid');
        })
        .catch(function() {
          clearTimeout(tid);
          if (attemptsLeft > 1) {
            doUpload(blob, attemptsLeft - 1);
          } else {
            _wbUploading[zoneId] = false;
            zone.classList.remove('wb-uploading');
            hidden.value = 'UPLOAD_FAILED';
            if (pct) pct.textContent = '⚠ Photo à envoyer par email';
            var field = zone.closest('.wb-field');
            if (field) field.classList.remove('wb-invalid');
          }
        });
    }, delay);
  }

  resizeToJpeg(file, 900, 0.80, function(blob) {
    if (!blob) blob = file;
    doUpload(blob, 5);
  });
}

/* ─── Companion products ─────────────────────────────────────────────────── */

var _wbCart = {};   // quantité RÉELLE au panier (semée depuis /cart.js, tenue à jour après chaque appel)
var _wbVoulu = {};  // quantité VOULUE par companion — le DERNIER choix du client

/* (03/09) FILE + RÉESSAIS + ÉTAT VOULU pour TOUS les appels panier.
   Mesuré en réel : deux présélections qui partent EN MÊME TEMPS font une rafale → 429 →
   la ligne (durée, chanson) manque EN SILENCE. Et la file seule gardait un trou : les
   drapeaux étaient lus AU CLIC, avant la réponse de l'appel précédent — un premier clic
   sur « Non » (chanson) ou « 30s » pendant que la présélection partait laissait l'option
   au panier. Ici chaque clic pose la quantité VOULUE, et la tâche en file relit cette
   cible AU MOMENT où elle s'exécute : des clics rapprochés convergent vers le dernier
   choix, jamais vers un mélange. Au chargement, /cart.js sème l'état réel du panier :
   un client qui REVIENT sur la page repart de ce qu'il a vraiment. */
var _wbFile = fetch('/cart.js')
  .then(function (r) { return r.ok ? r.json() : { items: [] }; })
  .then(function (cart) {
    (cart.items || []).forEach(function (it) {
      for (var k in WB_VARIANTS) {
        if (WB_VARIANTS[k] === it.variant_id) _wbCart[k] = it.quantity;
      }
    });
  })
  .catch(function () {});

function _wbPause(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

function _wbEssai(url, corps, n) {
  return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(corps) })
    .then(function (r) {
      if (r.ok) return r;
      if (n < 3) return _wbPause(700 * Math.pow(2, n)).then(function () { return _wbEssai(url, corps, n + 1); });
      console.warn('[wb] panier KO définitif', url, r.status, corps);
      throw new Error('cart ' + r.status);
    }, function (e) {
      if (n < 3) return _wbPause(700 * Math.pow(2, n)).then(function () { return _wbEssai(url, corps, n + 1); });
      console.warn('[wb] panier injoignable', url, e);
      throw e;
    });
}

/* Pose la quantité voulue et met en file la réconciliation. TOUTE mutation du panier
   passe ICI — jamais un fetch('/cart/...') direct (règle SHOPIFY.md, incident du 03/09). */
/* (12/09, demande Rayan) SYNCHRO DIFFÉRÉE : pendant la saisie, aucun appel panier —
   le pixel Meta ne voit donc plus d'AddToCart sur un simple clic d'option. Tout part
   d'un coup au clic « CRÉER MON FILM » (_wbFlushOptions), et le panier est aligné
   EXACTEMENT sur le form (les options périmées d'une session passée sont remises à zéro). */
var _wbDiffere = true;   // (15/10, Rayan) « le bouton du form doit être compté comme ATC » : AUCUN appel panier pendant la
                          // saisie (les options précochées et cliquées restent dans _wbVoulu) ; tout part au clic
                          // « CRÉER MON FILM » (_wbFlushOptions). Avant (05/10→15/10) : chaque option = un /cart/add =
                          // un AddToCart Meta + une « session avec ajout » Shopify dès la 1re frappe (précochage).

function _wbSetQty(key, qty) {
  var variantId = WB_VARIANTS[key];
  if (!variantId) return Promise.resolve();  // variant ID not configured
  _wbVoulu[key] = qty;
  if (_wbDiffere) return Promise.resolve();
  var lance = function () {
    var cible = _wbVoulu[key] || 0;
    var actuel = _wbCart[key] || 0;
    if (cible === actuel) return;
    var url = actuel ? '/cart/change.js' : '/cart/add.js';
    var corps = actuel ? { id: String(variantId), quantity: cible } : { id: variantId, quantity: cible };
    return _wbEssai(url, corps, 0).then(function () { _wbCart[key] = cible; });
  };
  var p = _wbFile.then(lance, lance);
  _wbFile = p.catch(function () {});   // la file survit à un échec définitif
  return p.catch(function () {});
}

/* (02/10) ANTI-DOUBLE-FILM. Le film lui-même part par l'envoi natif du formulaire
   (/cart/add) : rien ne le retirait d'un passage précédent. Un client qui revenait du
   paiement pour changer une option puis recliquait se retrouvait avec DEUX films
   (reproduit sur le site : 132,80 € au lieu de 82,90 €). Avant d'envoyer, on retire donc
   toute ligne « film » déjà au panier : le panier est l'exact reflet du formulaire.
   Passe par la même file et les mêmes réessais que les options. Si le retrait échoue,
   on envoie quand même (jamais de client retenu) — on retombe alors sur l'ancien défaut. */
function _wbRetireFilms() {
  var champ = document.querySelector('#wb-product-form [name="id"]');
  var filmId = champ ? Number(champ.value) : 0;
  if (!filmId) return Promise.resolve();
  var tache = function () {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var cles = (cart.items || [])
          .filter(function (it) { return it.variant_id === filmId; })
          .map(function (it) { return it.key; });
        return cles.reduce(function (p, cle) {
          return p.then(function () { return _wbEssai('/cart/change.js', { id: cle, quantity: 0 }, 0); });
        }, Promise.resolve());
      });
  };
  var p = _wbFile.then(tache, tache);
  _wbFile = p.catch(function () {});
  return p.catch(function () {});
}

function _wbFlushOptions() {
  _wbDiffere = false;   // le temps d'envoyer ce qui est voulu
  var films = _wbRetireFilms();   // en tête de file : c'est lui qui fausse le prix
  var ps = Object.keys(WB_VARIANTS).map(function(k) { return _wbSetQty(k, _wbVoulu[k] || 0); });
  ps.push(films);
  _wbDiffere = true;    // (15/10) et on repasse en différé : un retour depuis le panier pour modifier
                        // ne renvoie rien au panier avant le prochain clic « CRÉER MON FILM »
  return Promise.race([
    Promise.all(ps),
    new Promise(function(res) { setTimeout(res, 4000); })   // fail-open : on ne retient jamais longtemps
  ]);
}

function wbAddCompanion(key) { return _wbSetQty(key, 1); }

/* (31/08) « Ajouter Personnage » : 3 personnes → qty 1, 4 personnes → qty 2. */
function wbSetCompanionQty(key, qty) { return _wbSetQty(key, qty); }

function wbRemoveCompanion(key) { return _wbSetQty(key, 0); }

/* ─── Option handlers ────────────────────────────────────────────────────── */

function wbHandleDuree(select) {
  wbRemoveCompanion('duree_60s');
  wbRemoveCompanion('duree_90s');
  if (select.value === '60 secondes') {
    wbAddCompanion('duree_60s');
  } else if (select.value === '90 secondes') {
    wbAddCompanion('duree_90s');
  }
}

function wbHandleMusique(select) {
  if (select.value === 'Chanson personnalisée') {
    wbAddCompanion('chanson');
  } else {
    wbRemoveCompanion('chanson');
  }
}

function wbHandleLivraison(select) {
  if (select.value === 'Express (24H)') {
    wbAddCompanion('express');
  } else {
    wbRemoveCompanion('express');
  }
}

function wbHandleYoutube(select) {
  if (select.value === 'Oui') {
    wbAddCompanion('youtube');
  } else {
    wbRemoveCompanion('youtube');
  }
}

/* ─── (08/10, Rayan : « il faut savoir pourquoi c'est refusé, la raison ») MESURE DES REFUS.
   Chaque clic sur « CRÉER MON FILM » envoie UNE ligne à notre serveur : refusé (avec la liste
   exacte des champs manquants) ou accepté, le numéro d'essai, l'identifiant wb_id (= étiquette
   Clarity « wb_client ») et la provenance (pub Meta / Google). Aucun texte saisi par le client.
   sendBeacon en text/plain : rien n'attend, rien ne bloque le formulaire. ─── */
var _WB_NOMS_CHAMPS = {
  'wb-f-destinataire': 'prénom destinataire', 'wb-f-occasion': 'occasion',
  'wb-f-photo1': 'photo perso 1', 'wb-f-yeux1': 'yeux perso 1',
  'wb-f-pers2nom': 'prénom perso 2', 'wb-f-photo2': 'photo perso 2', 'wb-f-yeux2': 'yeux perso 2',
  'wb-f-pers3nom': 'prénom perso 3', 'wb-f-photo3': 'photo perso 3', 'wb-f-yeux3': 'yeux perso 3',
  'wb-f-pers4nom': 'prénom perso 4', 'wb-f-photo4': 'photo perso 4', 'wb-f-yeux4': 'yeux perso 4',
  'wb-f-narration': 'histoire (narration)', 'wb-f-musique': 'musique', 'wb-f-duree': 'durée',
  'wb-f-livraison': 'livraison', 'wb-f-youtube': 'streaming youtube', 'wb-f-ton': 'ton', 'wb-f-ajouter': 'ajouter personnage'
};
function _wbTraceForm(issue, champs) {
  try {
    var essai = 1;
    if (issue !== 'complet') {   // « complet » = tout rempli (pas un clic) : ne compte pas comme essai
      try { essai = (parseInt(sessionStorage.getItem('wb_essais') || '0', 10) || 0) + 1; sessionStorage.setItem('wb_essais', String(essai)); } catch (e) {}
    } else { essai = 0; }
    var details = (champs || []).map(function (f) {
      var nom = _WB_NOMS_CHAMPS[f.id] || f.id;
      var m = /^wb-f-photo(\d)$/.exec(f.id || '');
      if (m) {   // photo : jamais choisie, ou envoi encore en cours / raté ?
        var z = document.getElementById('wb-upload' + m[1]);
        nom += (z && z.classList.contains('wb-has-file')) ? ' (choisie, envoi pas fini)' : ' (aucune photo choisie)';
      }
      return nom;
    });
    var id = ''; try { id = localStorage.getItem('wb_id') || ''; } catch (e) {}
    var q = location.search || '';
    var source = /fbclid|utm_source=facebook|utm_source=ig|instagram/i.test(q + document.referrer) ? 'meta'
      : (/gclid|gad_source|gbraid|wbraid/i.test(q) ? 'google ads' : (/google\./i.test(document.referrer) ? 'google' : 'autre'));
    var corps = JSON.stringify({ issue: issue, champs: details, essai: essai, wb_id: id, source: source,
      page: location.pathname, ua: navigator.userAgent, largeur: window.innerWidth });
    var url = 'https://dashboard.wave-beats.com/api/form-trace';
    if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([corps], { type: 'text/plain' }));
    else fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: corps });
  } catch (e) { /* jamais bloquant */ }
}

/* ─── Form validation & submit ───────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('wb-product-form');
  if (!form) return;

  /* (03/09) OPTIONS PRÉSÉLECTIONNÉES — le panier ne se remplit qu'à la PREMIÈRE
     interaction réelle. Présélectionner en ajoutant au panier dès le chargement
     mettrait 48 € d'options dans le panier de CHAQUE visiteur, y compris ceux qui
     rebondissent : ils repartiraient avec une chanson et une durée SANS film, et les
     relances de panier abandonné leur parleraient d'un produit qu'ils n'ont pas choisi.
     Ici : l'affichage est juste tout de suite, le panier suit dès qu'il touche au form. */
  var _wbSync = false;
  function wbSyncPreselection() {
    if (_wbSync) return;
    _wbSync = true;
    [['wb-musique-val', 'wbHandleMusique'], ['wb-duree-val', 'wbHandleDuree'],
     ['wb-livraison-val', 'wbHandleLivraison'], ['wb-youtube-val', 'wbHandleYoutube']]
      .forEach(function(p) {
        var el = document.getElementById(p[0]), fn = window[p[1]];
        if (el && el.value && typeof fn === 'function') fn({ value: el.value });
      });
  }
  ['click', 'input', 'change'].forEach(function(ev) {
    form.addEventListener(ev, wbSyncPreselection, { once: true, capture: true });
  });

  // Blocs fermés = champs désactivés dès l'ouverture de la page (voir _wbMajChampsFermes).
  _wbMajChampsFermes();

  // Le total doit être juste DÈS L'OUVERTURE (les options présélectionnées comptent).
  // `wbTotal` sort immédiatement s'il n'y a pas de bloc .wb-total → forms UK/Mariage intacts.
  if (typeof wbTotal === 'function') wbTotal();

  form.addEventListener('submit', function(e) {
    /* (11/09, règle Rayan — confirmée par le filet backend UPLOAD_FAILED) Le submit part
       TOUJOURS, instantanément. Photo choisie mais envoi pas terminé au clic → la commande
       part marquée UPLOAD_FAILED : le pipeline se suspend et l'email automatique « envoyez-
       nous vos photos » part au client. Seul cas bloquant : AUCUNE photo choisie. */
    for (var _n = 1; _n <= 4; _n++) {
      var _z = document.getElementById('wb-upload' + _n);
      var _h = document.getElementById('wb-photo' + _n + '-url');
      if (_z && _h && !_h.value && _z.classList.contains('wb-has-file')) _h.value = 'UPLOAD_FAILED';
    }
    var valid = true;
    var firstError = null;

    function require(fieldId, valueGetter) {
      var field = document.getElementById(fieldId);
      if (!field) return;
      var val = valueGetter ? valueGetter() : field.querySelector('input,select,textarea');
      var empty = val === '' || val === null || (val && val.value === '');
      if (empty) {
        field.classList.add('wb-invalid');
        valid = false;
        if (!firstError) firstError = field;
      } else {
        field.classList.remove('wb-invalid');
      }
    }

    // Étape 1 — always required
    require('wb-f-destinataire', function() {
      return form.querySelector('[name="properties[Destinataire]"]').value;
    });
    require('wb-f-occasion', function() {
      return form.querySelector('[name="properties[Occasion]"]').value;
    });
    require('wb-f-photo1', function() {
      return document.getElementById('wb-photo1-url').value;
    });
    require('wb-f-yeux1', function() {
      return form.querySelector('[name="properties[couleur-yeux-pers1]"]').value;
    });
    require('wb-f-ajouter', function() {
      return form.querySelector('[name="properties[ajouter-personnage]"]').value;
    });

    // Étape 1 — personnage 2 (only if visible)
    var pers2 = document.getElementById('wb-pers2');
    if (pers2 && pers2.classList.contains('wb-visible')) {
      require('wb-f-pers2nom', function() {
        return form.querySelector('[name="properties[personnage2]"]').value;
      });
      require('wb-f-photo2', function() {
        return document.getElementById('wb-photo2-url').value;
      });
      require('wb-f-yeux2', function() {
        return form.querySelector('[name="properties[couleur-yeux-pers2]"]').value;
      });
    }

    // Étape 1 — personnages 3 et 4 (chacun seulement s'il est visible) — généralisé le 31/08
    [3, 4].forEach(function(n) {
      var box = document.getElementById('wb-pers' + n);
      if (!box || !box.classList.contains('wb-visible')) return;
      require('wb-f-pers' + n + 'nom', function() {
        var el = form.querySelector('[name="properties[personnage' + n + ']"]'); return el ? el.value : '';
      });
      require('wb-f-photo' + n, function() {
        var el = document.getElementById('wb-photo' + n + '-url'); return el ? el.value : '';
      });
      require('wb-f-yeux' + n, function() {
        var el = form.querySelector('[name="properties[couleur-yeux-pers' + n + ']"]'); return el ? el.value : '';
      });
    });

    // Étape 2 — (11/09) thème SUPPRIMÉ (la narration est le signal primaire)
    require('wb-f-ton', function() {
      return form.querySelector('[name="properties[Ton]"]').value;
    });
    require('wb-f-narration', function() {
      return form.querySelector('[name="properties[Narration]"]').value.trim();
    });
    require('wb-f-musique', function() {
      return form.querySelector('[name="properties[Musique du film]"]').value;
    });

    // Étape 3
    require('wb-f-duree', function() {
      return form.querySelector('[name="properties[Durée souhaitée]"]').value;
    });
    require('wb-f-livraison', function() {
      return form.querySelector('[name="properties[Livraison]"]').value;
    });
    require('wb-f-youtube', function() {
      return form.querySelector('[name="properties[Streaming youtube]"]').value;
    });

    if (!valid) {
      e.preventDefault();
      _wbTraceForm('refus', Array.prototype.slice.call(form.querySelectorAll('.wb-invalid')));
      if (firstError) {
        /* (02/10) On ouvre TOUTES les étapes qui ont un champ manquant, pas seulement la
           première. Avant : l'étape 3 restait fermée tant que l'étape 2 n'était pas
           juste — le client corrigeait, recliquait, découvrait l'erreur suivante (mesuré :
           jusqu'à 6 clics ; 17 clics pour 7 sessions le 02/10). Il voit tout d'un coup. */
        var manquants = form.querySelectorAll('.wb-invalid');
        for (var _m = 0; _m < manquants.length; _m++) {
          var stepBody = manquants[_m].closest('.wb-step-body');
          if (stepBody && stepBody.classList.contains('wb-hidden')) {
            stepBody.classList.remove('wb-hidden');
            var stepHeader = stepBody.previousElementSibling;
            if (stepHeader) stepHeader.classList.remove('wb-closed');
          }
        }
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    /* form VALIDE : pousser les options au panier D'UN COUP, puis partir (≈400 ms). */
    if (!form.dataset.flushFait) {
      e.preventDefault();
      _wbTraceForm('ok', []);
      if (typeof _wbPixelCustom === 'function') _wbPixelCustom('CreerMonFilm', { currency: 'EUR', value: parseFloat((document.getElementById('wb-total') || {}).textContent) || 49.9 });   // (16/10) 1 par clic
      form.dataset.flushFait = '1';
      var btn = document.getElementById('wb-submit');
      if (btn) btn.disabled = true;   // (05/10) plus de « Préparation… » : le panier est déjà à jour
      _wbFlushOptions().then(function() {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  });
});

/* (05/10, Rayan : « je suis revenu pour modifier, le bouton est bloqué sur Préparation de votre commande »)
   Depuis le retour au PANIER, revenir en arrière est fréquent : Safari/Chrome réaffichent la page FIGÉE
   (cache arrière/avant), bouton désactivé et envoi marqué « fait ». On remet le bouton en état à chaque
   réaffichage, et on repasse en mode différé : le prochain clic refait la synchro complète (retrait
   du film déjà au panier compris → jamais de doublon). */
window.addEventListener('pageshow', function () {
  var form = document.getElementById('wb-product-form');
  var btn = document.getElementById('wb-submit');
  if (form) delete form.dataset.flushFait;
  if (btn) { btn.disabled = false; btn.textContent = 'CRÉER MON FILM →'; }
});


/* ─── (11/09) PERSISTANCE DU FORM — le checkout direct rend le retour arrière fréquent,
   et un retour = page blanche (constaté par Rayan). Chaque champ est sauvé en localStorage
   à la saisie et restauré au chargement : textes, pilules re-cochées, photos marquées
   « ajoutée » (la miniature blob ne survit pas, l'état oui), récap recalculé. TTL 48 h. ─── */
(function() {
  var CLE = 'wb_form_fr_v1', TTL = 48 * 3600 * 1000;
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || !form.querySelector('#wb-submit')) return;
  function champs() {
    return [...form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["], input[type="hidden"][id]')]
      .filter(function(e) { return e.type !== 'file'; });
  }
  function sauve() {
    try {
      var d = { t: Date.now(), v: {}, ap: {} };
      champs().forEach(function(e) { var k = e.id || e.name; if (k && e.value) d.v[k] = e.value; });
      // vignettes photo : blob → mini dataURL (la blob meurt avec la page, la dataURL non)
      for (var n = 1; n <= 4; n++) {
        var im = document.querySelector('#wb-upload' + n + ' .wb-preview img');
        if (im && im.src && im.naturalWidth) {
          try {
            var c = document.createElement('canvas');
            var k2 = Math.min(1, 200 / im.naturalWidth);
            c.width = Math.round(im.naturalWidth * k2); c.height = Math.round(im.naturalHeight * k2);
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            var du = c.toDataURL('image/jpeg', 0.7);
            if (du.length < 120000) d.ap[n] = du;
          } catch (er) {}
        }
      }
      localStorage.setItem(CLE, JSON.stringify(d));
    } catch (er) {}
  }
  function restaure() {
    var d;
    try { d = JSON.parse(localStorage.getItem(CLE) || 'null'); } catch (er) { return; }
    if (!d || !d.v || Date.now() - d.t > TTL) return;
    champs().forEach(function(e) {
      var k = e.id || e.name;
      if (!(k in d.v)) return;
      // les cachés d'options ont une valeur PAR DÉFAUT (présélections) : on écrase toujours ;
      // les champs texte ne se remplissent que s'ils sont vides.
      if (e.type === 'hidden' || !e.value) e.value = d.v[k];
    });
    // re-cocher la pilule qui correspond à chaque valeur cachée restaurée
    ['wb-occasion-val', 'wb-duree-val', 'wb-musique-val', 'wb-livraison-val', 'wb-youtube-val',
     'wb-yeux1-val', 'wb-yeux2-val', 'wb-yeux3-val', 'wb-yeux4-val'].forEach(function(hid) {   // (11/10) + couleurs des yeux : la valeur revenait, la pastille restait éteinte
      var h = document.getElementById(hid);
      if (!h || !h.value) return;
      var groupe = [...document.querySelectorAll('.wb-pill')].filter(function(p) {
        return (p.getAttribute('onclick') || '').indexOf("'" + hid + "'") !== -1;
      });
      groupe.forEach(function(p) { p.classList.toggle('wb-on', p.dataset.v === h.value); });
    });
    // zones photo : url restaurée = état « ajoutée »
    for (var n = 1; n <= 4; n++) {
      var u = document.getElementById('wb-photo' + n + '-url');
      var z = document.getElementById('wb-upload' + n);
      if (u && u.value && z) {
        z.classList.add('wb-has-file');
        var pct = z.querySelector('.wb-progress-pct');
        if (pct) pct.textContent = '✓ Photo ajoutée';
        var ap = d.ap && d.ap[n];
        var pv = z.querySelector('.wb-preview');
        if (ap && pv) {
          var im2 = pv.querySelector('img');
          if (im2) im2.src = ap;
          pv.style.display = 'flex';
        }
      }
    }
    // (11/10, client Google Ads du 11/10 : 20 min refaites) les personnages AJOUTÉS revenaient
    // dans des blocs FERMÉS — invisibles, champs désactivés donc non envoyés. On rouvre chaque
    // bloc qui a une donnée sauvée, puis la synchro habituelle (bouton, quantité payante, total).
    var rouverts = 0;
    for (var p = 2; p <= 4; p++) {
      var bloc = document.getElementById('wb-pers' + p);
      if (!bloc || bloc.classList.contains('wb-visible')) continue;
      var a1 = d.v['properties[personnage' + p + ']'], a2 = d.v['wb-photo' + p + '-url'], a3 = d.v['wb-yeux' + p + '-val'];
      if (a1 || a2 || a3) { bloc.classList.add('wb-visible'); rouverts++; }
    }
    if (rouverts && typeof _wbPersSync === 'function') _wbPersSync();
    // prénoms dans « Couleur des yeux de … »
    for (var q = 1; q <= 4; q++) {
      var nomEl = q === 1 ? form.querySelector('[name="properties[Destinataire]"]') : form.querySelector('[name="properties[personnage' + q + ']"]');
      if (nomEl && nomEl.value && typeof wbEyeName === 'function') wbEyeName(nomEl, 'wb-eye-name' + q, '');
    }
    if (typeof wbTotal === 'function') wbTotal();
  }
  var tmr = null;
  form.addEventListener('input', function() { clearTimeout(tmr); tmr = setTimeout(sauve, 300); });
  form.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('.wb-pill')) setTimeout(sauve, 150);
  });
  restaure();
})();


/* (11/09, Rayan) Nombre de personnages AJOUTÉS en un choix (le destinataire n'est pas
   compté) : Non · +1 (inclus) · +2 (+15 €) · +3 (+30 €). Réutilise wbAddPerson /
   wbRemovePerson : nettoyage, validation et produit-quantité identiques. */
function wbSetPersCount(n) {
  var ouverts = function() {
    return _wbPersBlocks().filter(function(b) { return b.classList.contains('wb-visible'); }).length;
  };
  var garde = 12;
  while (ouverts() > n && garde--) wbRemovePerson(null);
  while (ouverts() < n && garde--) wbAddPerson();
}


function wbPersOnOff(oui) {
  if (!oui) { wbSetPersCount(0); return; }
  var ouverts = _wbPersBlocks().filter(function(b) { return b.classList.contains('wb-visible'); }).length;
  if (ouverts === 0) wbSetPersCount(1);   // Oui = au moins une personne en plus
  else _wbPersSync();                      // déjà ouvert : juste re-marquer
}


/* ─── (12/09, Rayan) ÉVÉNEMENT « FormCompleted » pour Meta ─────────────────────────────
   Part UNE FOIS dès que le DERNIER champ obligatoire est rempli — clic ou pas. Distinct
   d'InitiateCheckout (les « tout rempli, jamais cliqué » deviennent retargetables).
   >> COLLER L'ID DU PIXEL META CI-DESSOUS — vide = inactif (aucun envoi, aucun risque).
   Le fbq est initialisé SANS PageView : seul trackCustom part, pas de doublon avec le
   pixel du canal Shopify. */
window.WB_META_PIXEL_ID = '1248576039623233';   // pixel du canal Shopify (lu dans la config web-pixels)
/* (16/10, Rayan) UN événement par clic « CRÉER MON FILM » : `CreerMonFilm`, envoyé par NOTRE fbq (le pixel du canal
   Shopify envoie, lui, un AddToCart PAR LIGNE du panier — mesuré : 3-4 par client). Dans Meta : conversion
   personnalisée sur l'événement CreerMonFilm → colonne « vrais ajouts » dans le gestionnaire de pubs. */
function _wbPixelCustom(nom, donnees) {
  try {
    if (!window.WB_META_PIXEL_ID) return;
    if (!window.fbq) {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', window.WB_META_PIXEL_ID);
    }
    window.fbq('trackCustom', nom, donnees || {});
  } catch (e) {}
}
(function() {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || !form.querySelector('#wb-submit')) return;
  function complet() {
    var v = function(sel) { var e = form.querySelector(sel) || document.getElementById(sel); return e && String(e.value || '').trim(); };
    // (11/10) l'occasion n'est exigée que si le champ existe (retiré du form FR : la chanson ne la chante plus)
    if (!v('[name="properties[Destinataire]"]') || (form.querySelector('[name="properties[Occasion]"]') && !v('[name="properties[Occasion]"]'))) return false;
    if (!v('[name="properties[couleur-yeux-pers1]"]') || !v('[name="properties[Narration]"]')) return false;
    var photo1 = document.getElementById('wb-photo1-url');
    var zone1 = document.getElementById('wb-upload1');
    if (!((photo1 && photo1.value) || (zone1 && zone1.classList.contains('wb-has-file')))) return false;
    if (!v('wb-musique-val') || !v('wb-duree-val') || !v('wb-livraison-val') || !v('wb-youtube-val')) return false;
    // personnages ouverts : chacun complet (prénom + photo + yeux)
    var ouverts = document.querySelectorAll('.wb-pers.wb-visible');
    for (var i = 0; i < ouverts.length; i++) {
      var b = ouverts[i], n = b.id.replace('wb-pers', '');
      var nom = b.querySelector('[name="properties[personnage' + n + ']"]');
      var oeil = b.querySelector('[name="properties[couleur-yeux-pers' + n + ']"]');
      var ph = document.getElementById('wb-photo' + n + '-url');
      var zn = document.getElementById('wb-upload' + n);
      if (!(nom && nom.value.trim()) || !(oeil && oeil.value)) return false;
      if (!((ph && ph.value) || (zn && zn.classList.contains('wb-has-file')))) return false;
    }
    return true;
  }
  function envoie() {
    try {
      if (sessionStorage.getItem('wb_form_completed')) return;
      sessionStorage.setItem('wb_form_completed', '1');
    } catch (er) {}
    window.__wbFormCompleted = true;   // témoin pour les tests
    if (typeof _wbTraceForm === 'function') _wbTraceForm('complet', []);   // (08/10) même moment, notre mesure
    if (!window.WB_META_PIXEL_ID) return;
    if (!window.fbq) {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', window.WB_META_PIXEL_ID);
    }
    window.fbq('trackCustom', 'FormCompleted');
  }
  var tmrFC = null;
  function verifie() {
    clearTimeout(tmrFC);
    tmrFC = setTimeout(function() { if (!window.__wbFormCompleted && complet()) envoie(); }, 400);
  }
  form.addEventListener('input', verifie);
  form.addEventListener('click', function(e) { if (e.target.closest && e.target.closest('.wb-pill, .wb-toggle-track')) verifie(); });
})();
